import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const PresentBase = (
  <path
    fill='currentColor'
    d='M11.205 13.542H5.636v1.541h5.569v6.167h1.59v-6.167h5.569v-1.541h-5.569V8.146h-1.59v5.396zm7.159-3.084v10.02c0 .427-.354.772-.797.772H6.433c-.44 0-.797-.343-.797-.772v-10.02H3.648c-.22 0-.398-.166-.398-.382V8.528c0-.211.173-.382.398-.382h16.704c.22 0 .398.166.398.382v1.548c0 .211-.173.382-.398.382h-1.988zM6.432 5.448c0-1.49 1.25-2.698 2.784-2.698C10.754 2.75 12 3.96 12 5.448v2.698H9.216c-1.538 0-2.784-1.211-2.784-2.698zM9.216 6.99h1.59V5.448c0-.85-.713-1.542-1.59-1.542-.877 0-1.591.692-1.591 1.542 0 .85.714 1.542 1.59 1.542zM12 5.448c0-1.49 1.25-2.698 2.784-2.698 1.538 0 2.784 1.21 2.784 2.698 0 1.49-1.25 2.698-2.784 2.698H12V5.448zm1.193 1.542h1.591c.877 0 1.591-.692 1.591-1.542 0-.85-.714-1.542-1.59-1.542-.878 0-1.592.692-1.592 1.542V6.99z'
  />
)

export const Present = createIcon({
  displayName: 'Present',
  viewBox: '0 0 24 24',
  path: PresentBase,
})

export const PresentBase2 = (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M4.098 5c-.197-.322-.298-.718-.298-1.2 0-.95.714-1.8 1.8-1.8 1.087 0 1.964.728 2.4 1.868C8.436 2.728 9.313 2 10.4 2c1.086 0 1.8.85 1.8 1.8 0 .482-.101.878-.298 1.2h.898c.663 0 1.2.537 1.2 1.2v1.2c0 .663-.537 1.2-1.2 1.2v4.2c0 .663-.537 1.2-1.2 1.2H4.4c-.663 0-1.2-.537-1.2-1.2V8.6C2.537 8.6 2 8.063 2 7.4V6.2C2 5.537 2.537 5 3.2 5h.898zM7.4 6.2H3.2v1.2h4.2V6.2zm5.4 1.2H8.6V6.2h4.2v1.2zm-5.4 5.4V8.6h-3v4.2h3zm4.2 0h-3V8.6h3v4.2zm-6-9.6c-.372 0-.6.271-.6.6 0 .752.61 1.11 2.058 1.185C6.897 3.867 6.298 3.2 5.6 3.2zm3.3 1.785c.16-1.118.76-1.785 1.458-1.785.372 0 .6.271.6.6 0 .752-.61 1.11-2.058 1.185z'
  />
)

export const Present2 = createIcon({
  displayName: 'Present2',
  viewBox: '0 0 16 16',
  path: PresentBase2,
})
